<template>
  <div class="change-info-container">
    <a-card title="修改信息" class="change-info-card">
      <a-form
          name="change-info"
          :model="formState"
          @finish="onFinish"
          @finishFailed="onFinishFailed"
      >
        <a-form-item
            label="用户名"
            name="username"
        >
          <a-input v-model:value="formState.username" placeholder="用户名" />
        </a-form-item>


        <a-form-item
            label="头像"
            name="avatar"
        >
          <a-upload
              list-type="picture-card"
              :show-upload-list="false"
              :before-upload="beforeUpload"
          >
            <img
                v-if="imageUrl"
                :src="imageUrl"
                alt="avatar"
                style="width: 100%"
            />

            <div v-else>
              <plus-outlined />
              <div style="margin-top: 8px">上传</div>
            </div>
          </a-upload>
        </a-form-item>

        <a-form-item
            label="个性签名"
            name="signature"
        >
          <a-textarea v-model:value="formState.signature" placeholder="个性签名" />
        </a-form-item>

        <a-form-item>
          <div id="link-container">
            <router-link to="/changePwd" id="enter-backend">修改密码...</router-link>
          </div>
          <a-button type="primary" html-type="submit" block>
            确认修改
          </a-button>
          <a-button type="default" :style="'margin-top: 10px'" @click="deleteUser" block>
            删除账户
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script setup>
import { ref,reactive } from "vue"
import { message } from "ant-design-vue"
import { PlusOutlined } from '@ant-design/icons-vue'
import request from "@/utils/request.js";
import router from "@/router/index"
const formState = reactive({
  username: "",
  avatar: "",
  signature: ""
})

const imageUrl = ref('')

const beforeUpload = (file) => {
  const isImage = file.type.startsWith('image/')
  if (!isImage) {
    message.error('只能上传图片文件！')
    return false
  }

  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isLt2M) {
    message.error('图片必须小于 2MB！')
    return false
  }

  const reader = new FileReader()
  reader.onload = (e) => {
    imageUrl.value = e.target.result
    formState.avatar = file
  }
  reader.readAsDataURL(file)

  return false
}
const onFinishFailed=()=>{
  message.error("修改失败！");
}
const onFinish=async ()=>{
  try{
    const formData=new FormData()
    formData.append("username",formState.username)
    formData.append("signature",formState.signature)
    formData.append("img",formState.avatar)
    const newToken=(await request.put("/auth/change", formData)).data
    await router.replace("/");
    message.success("修改成功！")
    // console.log(newToken)
    localStorage.setItem("token", newToken)
  } catch (err)
  {
    message.error(err.message || "修改失败")
  }
}
const deleteUser=async ()=>{
  if(confirm("⚠️你真的要删除你的账号吗？这个账号将被永久删除，无法恢复！")) {
    try {
      await request.delete("/auth/delete");
      message.success("删除成功");
      localStorage.removeItem("token");
      await router.replace("/login");
    } catch (err) {
      message.error("删除失败！");
    }
  }
}
</script>

<style scoped>
.change-info-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(120deg, #1890ff, #87cefa);
}

.change-info-card {
  width: 450px;
  border-radius: 10px;
}
#link-container{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>